<template>
  <div>
    <ContactsBanner />

    <section class="elevation-1 rounded-sm d-flex flex-wrap pa-6 mb-4">
      <ContactsItemBlock
        v-for="(contact, i) in context.company_contacts"
        :key="i"
        :contact="contact"
        class="w-50 mb-4"
      />
    </section>

    <section class="elevation-1 rounded-sm pa-6">
      <div
        v-for="(ceo_contact, i) in context.company_ceo_contacts"
        :key="i"
      >
        <ContactsSeoProfile :profile="ceo_contact" />
        <ContactsAddresses :addresses="ceo_contact.addresses.all" />
      </div>

      <ContactsMap :map-data="context.company_ceo_contacts[0]" />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useContextStore } from 'src/store'
import ContactsMap from 'src/components/pages/info/contacts/components/ContactsMap.vue'
import ContactsBanner from 'src/components/pages/info/contacts/components/ContactsBanner.vue'
import ContactsItemBlock from 'src/components/pages/info/contacts/components/ContactsItemBlock.vue'
import ContactsAddresses from 'src/components/pages/info/contacts/components/ContactsAddresses.vue'
import ContactsSeoProfile from 'src/components/pages/info/contacts/components/ContactsSeoProfile.vue'
import type { ContextStore } from 'src/components/pages/info/contacts/types'

const { context }: ContextStore = useContextStore()
</script>
